// @flow
import { defineMessages } from 'react-intl';

export const accountStatuses = {
    MISSING_HUB: 'MISSING_HUB',
    PMZ_FIRMWARE: 'PMZ_FIRMWARE'
};

export const loginStatuses = {
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    NOT_AUTHORIZED: 'NOT_AUTHORIZED',
    OK: 'OK'
};

export const messages = defineMessages({
    missingUsernamePassword: {
        id: 'application.missing-username-password',
        defaultMessage: 'We need your username and password to continue. {needHelp}'
    },
    needHelp: {
        id: 'application.need-help',
        defaultMessage: 'Need help?'
    }
});

export const NEED_HELP_HREF = 'https://www.hivehome.com/cant-find-details';



// WEBPACK FOOTER //
// ./src/core/constants/application.js